import React, { useMemo } from 'react';
import ProductCard from './ProductCard';

const ProductGrid = ({ categories, currentPage, brand, searchQuery = '' }) => {
  // Complete product image paths for all brands
  const imagePaths = {
    exide: {
      'motor-cycle': [
        '/assets/Exide/EXIDE XPLORE 12XL2.5L-C 2.5 Ah-Battery.jpg',
        '/assets/Exide/EXIDE XPLORE XLTZ4A  4 Ah Battery.jpg',
        '/assets/Exide/z54.jpg',
        '/assets/Exide/z65.jpg',
        '/assets/Exide/EXIDE XPLORE 12XL5L-B 5 Ah Battery.jpg',
        '/assets/Exide/EXIDE XPLORE XLTZ7 6 Ah Battery.jpg',
        '/assets/Exide/xltz9.jpg',
        '/assets/Exide/EXIDE-XPLORE-12XL9-B-9-Ah-Battery.jpg',
        '/assets/Exide/EXIDE-XPLORE--XLTX14-12-Ah-Battery.jpg'
      ],
      'car': [
        '/assets/Exide/EXIDE-MILEAGE-ML38B20L-R-Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE ML40LBH-RBH Battery.jpg',
        '/assets/Exide/EXIDE-MILEAGE-MLDIN44R-LH-Battery.jpg',
        '/assets/Exide/EXIDE-MILEAGE-ML45D21LBH-Battery.jpg',
        '/assets/Exide/EXIDE-MILEAGE-MLDIN50-Battery.jpg',
        '/assets/Exide/EXIDE-MILEAGE-ML55D23L-Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE MLDIN55-R Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE MLDIN60 Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE MLDIN65LH Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE MLDIN66 Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE ML75D23LBH  Battery.jpg',
        '/assets/Exide/EXIDE-MILEAGE-MLDIN80-Batte.jpg',
        '/assets/Exide/EXIDE MILEAGEMLM42(ISS)Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE ML-DIN47RMF-ISS Battery.jpg',
        '/assets/Exide/EXIDE MILEAGE MLDIN70-ISS-Battery.jpg',
        '/assets/Exide/EXIDE-EEZY-EY34B19L-Battery.jpg',
        '/assets/Exide/EXIDE EEZY EY700L-700  Battery.jpg',
        '/assets/Exide/EXIDE-EEZY-EY80D26R-Battery.jpg',
        '/assets/Exide/EXIDE-EEZY-EY105D31L-R-Batt.jpg'
      ],
      'heavy-vehicles': [
        '/assets/Exide/EXIDE-XPRESS-XP800-Battery.jpg',
        '/assets/Exide/EXIDE-XPRESS-XP880-Battery.jpg',
        '/assets/Exide/EXIDE XPRESS XP1000 Battery.jpg',
        '/assets/Exide/expree300.jpg',
        '/assets/Exide/expree500.jpg',
        '/assets/Exide/xpree800.jpg',
        '/assets/Exide/x2000.jpg'
      ],
      'invamaster': [
        '/assets/Exide/IMST1000.jpg',
        '/assets/Exide/IMST1500.jpg',
        '/assets/Exide/inverter1200.jpg',
        '/assets/Exide/inverter1500.jpg',
        '/assets/Exide/Exide Inva master IMTT1650 Tall Tubular 165Ah Inverter Battery.jpg',
        '/assets/Exide/Exide Inva master IMTT1800 Tall Tubular 180Ah Inverter Battery.jpg',
        '/assets/Exide/inverter2000.jpg',
        '/assets/Exide/inverter2300.jpg'
      ],
      'invatubular': [
        '/assets/Exide/Exide-Inva-Tubular-IT500-Tall-Tubular-150Ah-Battery.jpg',
        '/assets/Exide/Exide Inva Tubular IT500 Plus Tall Tubular 180Ah Battery.jpg',
        '/assets/Exide/INVERTER-IT7500.jpg',
        '/assets/Exide/Exide Inva Tubular IT850 Plus Tall Tubular 230Ah Battery.jpg',
        '/assets/Exide/Exide Inva Tubular IT950 Tall Tubular 260Ah Battery.jpg'
      ],
      'instabrite': [
        '/assets/Exide/Exide-Instabrite-IB880-88-Ah-Battery.jpg',
        '/assets/Exide/Exide Instabrite IB1000 100 Ah Battery.jpg',
        '/assets/Exide/Exide Instabrite IB1500 150 Ah Battery.jpg',
        '/assets/Exide/Exide Instabrite IB1800 180 Ah Battery.jpg',
        '/assets/Exide/Exide Instabrite IBST750 75 Ah Battery.jpg',
        '/assets/Exide/Exide Instabrite IBTT1500 150 Ah Battery.jpg',
        '/assets/Exide/Exide Instabrite IBTT1800 180 Ah Battery.jpg'
      ],
      'solar': [
        '/assets/Exide/Exide-Solar-Battery-6LMS20-.jpg',
        '/assets/Exide/Exide Solar Battery 12V40AH 6SBZ40.jpg',
        '/assets/Exide/Exide-6LMS40-40AH-Solar-Tub.jpg',
        '/assets/Exide/FE00-6LMS60 12V 60AH Low Maint Tubular Solar Battery.jpg',
        '/assets/Exide/FE04-6LMS75  12V 75AH Low Maint Tubular Solar Battery.jpg',
        '/assets/Exide/FE00-6LMS100  Tubular Solar Battery.jpg',
        '/assets/Exide/FE00-6LMS120 Tubular Solar Battery.jpg',
        '/assets/Exide/FE02-6SBZ150 Tubular Solar Battery.jpg',
        '/assets/Exide/FE00-6LMS150 12V 150AH Low Maint Tubular Solar Battery.jpg',
        '/assets/Exide/FE00-6LMS180 12V 180AH Low Maint Tubular Solar Battery.jpg',
        '/assets/Exide/FE00-6LMS200 Tubular Solar Battery.jpg'
      ]
    },
    luminous: {
      'inverlast': [
        '/assets/Luminous/INVERLAST - ILST 8036.png',
        '/assets/Luminous/INVERLAST - ILST 10036.png',
        '/assets/Luminous/INVERLAST - ILST 12042.png',
        '/assets/Luminous/INVERLAST - ILTJ 18148.png',
        '/assets/Luminous/INVERLAST - ILTT 18000N.png',
        '/assets/Luminous/INVERLAST - ILTT 20048.png',
        '/assets/Luminous/INVERLAST - ILTT 24060.png',
        '/assets/Luminous/INVERLAST - ILTT 25060.png',
        '/assets/Luminous/INVERLAST - ILTT 26060.png',
        '/assets/Luminous/INVERLAST - XL 18060.png',
        '/assets/Luminous/INVERLAST - XL 18066.png',
        '/assets/Luminous/INVERLAST - XL 26060.jpg',
        '/assets/Luminous/INVERLAST - ILTT 18048N.png'
      ],
      'extra-charge': [
        '/assets/Luminous/EXTRA CHARGE - EC 18036.png'
      ],
      'red-charge': [
        '/assets/Luminous/RED CHARGE - RC 15000.png',
        '/assets/Luminous/RED CHARGE - RC 16000.png',
        '/assets/Luminous/RED CHARGE - RC 18000ST.png',
        '/assets/Luminous/RED CHARGE - RC 25000.png'
      ],
      'power-charge': [
        '/assets/Luminous/POWER CHARGE - PC 18042TJ.png',
        '/assets/Luminous/POWER CHARGE - PC 18042.png'
      ],
      'shakti-charge': [
        '/assets/Luminous/SHAKTI CHARGE - SC 12054.png',
        '/assets/Luminous/SHAKTI CHARGE - SC 18054.png'
      ],
      'invergel': [
        '/assets/Luminous/INVERGEL IGSTJ 18000.png'
      ],
      'life-max': [
        '/assets/Luminous/LIFE MAX - LM 18075.png'
      ],
      'solar-battery': [
        '/assets/Luminous/SOLAR-BATTERY---LPT-1220H.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1220L.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240H.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240L.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240H.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240L.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1220H.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1220L.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240H.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1240L.jpg',
        '/assets/Luminous/SOLAR-BATTERY---LPT-1220H.jpg',
        '/assets/Luminous/SOLAR-CHARGE-CONTROLLER-SCC.jpg'
      ]
    },
    amaron: {
      'car-batteries': [
        '/assets/Amaron/Amaron-GO-36B20L.jpg',
        '/assets/Amaron/Amaron-GO-38B20L.jpg',
        '/assets/Amaron/Amaron-GO-35-BH40B20L.jpg',
        '/assets/Amaron/Amaron-GO-35-BH38B20R.jpg',
        '/assets/Amaron/Amaron-GO-42B20R.jpg',
        '/assets/Amaron/Amaron-GO-50B20L.jpg',
        '/assets/Amaron/Amaron-GO-80-D-23L.jpg'
      ],
      'pro-rider': [
        '/assets/Amaron/Amaron-Pro-Rider-APBTX2.5.jpg',
        '/assets/Amaron/Amaron-Pro-Rider-APBTX5L-wi.jpg',
        '/assets/Amaron/Amaron-Pro-Rider--APBTX7R-w.jpg',
        '/assets/Amaron/Amaron-Pro-Rider-APBTX9Z-wi.jpg',
        '/assets/Amaron/Amaron-Pro-Rider--APBTZ4L-w.jpg',
        '/assets/Amaron/Amaron-Pro-Rider--APBTZ5L-w.jpg',
        '/assets/Amaron/Amaron-Pro-Rider-APBTZ7L1.jpg',
        '/assets/Amaron/Amaron-Pro-Rider-APBTZ9R-wi.jpg'
      ],
      'inverter-batteries': [
        '/assets/Amaron/135ah.jpg',
        '/assets/Amaron/165.jpg',
        '/assets/Amaron/200.jpg',
        '/assets/Amaron/200ah.jpg',
        '/assets/Amaron/220.jpg',
        '/assets/Amaron/Ainb100ah.jpg'
      ],
      'tubular-batteries': [
        '/assets/Amaron/AlitTubBat150AH.jpg',
        '/assets/Amaron/Amaron-Current--Tubular-Bat.jpg'
      ],
      'solar-combos': [
        '/assets/Amaron/650-va120ah.jpg',
        '/assets/Amaron/675va.jpg',
        '/assets/Amaron/1KVA ESATMAN1.jpeg',
        '/assets/Amaron/EASTMAN ONGIRD.jpeg'
      ]
    },
    lithium: {
      'torque-lithium': [
        '/assets/Lithium/L2.jpeg',
        '/assets/Lithium/L.jpeg',
        '/assets/Lithium/Lithium.jpeg'
      ],
      'wall-mounted': [
        '/assets/Lithium/L2.jpeg',
        '/assets/Lithium/L.jpeg'
      ],
      'solar-solutions': [
        '/assets/Lithium/Lithium.jpeg'
      ]
    },
    solar: {
      'off-grid': [
        '/assets/Solar/SOLAR-1KVA.jpeg',
        '/assets/Solar/SOLAR-2KVA.jpeg',
        '/assets/Solar/SOLAR-3KVA.jpeg',
        '/assets/Solar/SOLAR-4KVA.jpeg',
        '/assets/Solar/SOLAR-8KVA.jpeg',
        '/assets/Solar/SOLAR-10KVA.jpeg'
      ],
      'on-grid': [
        '/assets/Solar/On-gird-1.jpeg',
        '/assets/Solar/On-gird-2.jpeg',
        '/assets/Solar/On-gird-3.jpeg',
        '/assets/Solar/On-gird-4.jpeg'
      ],
      'hybrid': [
        '/assets/Solar/SOLAR-1KVA.jpeg',
        '/assets/Solar/SOLAR-2KVA.jpeg',
        '/assets/Solar/SOLAR-3KVA.jpeg',
        '/assets/Solar/SOLAR-4KVA.jpeg',
        '/assets/Solar/SOLAR-8KVA.jpeg',
        '/assets/Solar/SOLAR-10KVA.jpeg'
      ]
    }
  };

  const productNames = {
    exide: {
      'motor-cycle': [
        'EXIDE XPLORE 12XL2.5L-C 2.5 Ah Battery',
        'EXIDE XPLORE XLTZ4A 4 Ah Battery',
        'EXIDE XPLORE XLTZ5 4 Ah Battery',
        'EXIDE XPLORE XLTZ6 5 Ah Battery',
        'EXIDE XPLORE 12XL5L-B 5 Ah Battery',
        'EXIDE XPLORE XLTZ7 6 Ah Battery',
        'EXIDE XPLORE XLTZ9 8 Ah Battery',
        'EXIDE XPLORE 12XL9-B 9 Ah Battery',
        'EXIDE XPLORE XLTX14 12 Ah Battery'
      ],
      'car': [
        'EXIDE MILEAGE ML38B20L-R Battery',
        'EXIDE MILEAGE ML40LBH-RBH Battery',
        'EXIDE MILEAGE MLDIN44R-LH Battery',
        'EXIDE MILEAGE ML45D21LBH Battery',
        'EXIDE MILEAGE MLDIN50 Battery',
        'EXIDE MILEAGE ML55D23L Battery',
        'EXIDE MILEAGE MLDIN55-R Battery',
        'EXIDE MILEAGE MLDIN60 Battery',
        'EXIDE MILEAGE MLDIN65LH Battery',
        'EXIDE MILEAGE MLDIN66 Battery',
        'EXIDE MILEAGE ML75D23LBH Battery',
        'EXIDE MILEAGE MLDIN80 Battery',
        'EXIDE MILEAGE MLM42 ISS Battery',
        'EXIDE MILEAGE ML-DIN47RMF-ISS Battery',
        'EXIDE MILEAGE MLDIN70 ISS Battery',
        'EXIDE EEZY EY34B19L Battery',
        'EXIDE EEZY EY700L -700 Battery',
        'EXIDE EEZY EY80D26R Battery',
        'EXIDE EEZY EY105D31L-R Battery'
      ],
      'heavy-vehicles': [
        'EXIDE XPRESS XP800 Battery',
        'EXIDE XPRESS XP880 Battery',
        'EXIDE XPRESS XP1000 Battery',
        'EXIDE XPRESS XP1300 Battery',
        'EXIDE XPRESS XP1500 Battery',
        'EXIDE XPRESS XP1800 Battery',
        'EXIDE XPRESS XP2000 Battery'
      ],
      'invamaster': [
        'Exide IMST1000 Short Tubular 100Ah Inverter Battery',
        'Exide IMST1500 Short Tubular 150Ah Inverter Battery',
        'Exide Invamaster IMTT1200 Tall Tubular 115Ah Inverter Battery',
        'Exide Invamaster IMTT1500 Tall Tubular 150Ah Inverter Battery',
        'Exide Inva master IMTT1650 Tall Tubular 165Ah Inverter Battery',
        'Exide Inva master IMTT1800 Tall Tubular 180Ah Inverter Battery',
        'Exide Inva master IMTT2000 Tall Tubular 200Ah Inverter Battery',
        'Exide Inva master IMTT2300 Tall Tubular 220Ah Inverter Battery'
      ],
      'invatubular': [
        'Exide Inva Tubular IT500 Tall Tubular 150Ah Battery',
        'Exide Inva Tubular IT500 Plus Tall Tubular 180Ah Battery',
        'Exide Inva Tubular IT750 Tall Tubular 200Ah Battery',
        'Exide Inva Tubular IT850 Tall Tubular 230Ah Battery',
        'Exide Inva Tubular IT950 Tall Tubular 260Ah Battery'
      ],
      'instabrite': [
        'EXIDE EL IB880 88 Ah Battery',
        'EXIDE EL IB1000 100 Ah Battery',
        'EXIDE EL IB1500 150 Ah Battery',
        'EXIDE EL IB1800 180 Ah Battery',
        'EXIDE EL IBST750 75 Ah Battery',
        'EXIDE EL IBTT1500 150 Ah Battery',
        'EXIDE EL IBTT1800 180 Ah Battery'
      ],
      'solar': [
        'FE03-6LMS20 12V 20AH Low Maint Tubular Solar Battery',
        'FE01-6SBZ40 12V 40AH Low Maint Tubular Solar Battery',
        'FE04-6LMS40 12V 40AH Low Maint Tubular Solar Battery',
        'FE00-6LMS60 12V 60AH Low Maint Tubular Solar Battery',
        'FE04-6LMS75 12V 75AH Low Maint Tubular Solar Battery',
        'FE00-6LMS100 Tubular Solar Battery',
        'FE00-6LMS120 Tubular Solar Battery',
        'FE02-6SBZ150 Tubular Solar Battery',
        'FE00-6LMS150 12V 150AH Low Maint Tubular Solar Battery',
        'FE00-6LMS180 12V 180AH Low Maint Tubular Solar Battery',
        'FE00-6LMS200 Tubular Solar Battery'
      ]
    },
    luminous: {
      'inverlast': [
        'INVERLAST - ILST 8036',
        'INVERLAST - ILST 10036',
        'INVERLAST - ILST 12042',
        'INVERLAST - ILTJ 18148',
        'INVERLAST - ILTT 18000N',
        'INVERLAST - ILTT 20048',
        'INVERLAST - ILTT 24060',
        'INVERLAST - ILTT 25060',
        'INVERLAST - ILTT 26060',
        'INVERLAST - XL 18060',
        'INVERLAST - XL 18066',
        'INVERLAST - XL 26060',
        'INVERLAST - ILTT 18048N'
      ],
      'extra-charge': [
        'EXTRA CHARGE - EC 18036'
      ],
      'red-charge': [
        'RED CHARGE - RC 15000',
        'RED CHARGE - RC 16000',
        'RED CHARGE - RC 18000ST',
        'RED CHARGE - RC 25000'
      ],
      'power-charge': [
        'POWER CHARGE - PC 18042TJ',
        'POWER CHARGE - PC 18042'
      ],
      'shakti-charge': [
        'SHAKTI CHARGE - SC 12054',
        'SHAKTI CHARGE - SC 18054'
      ],
      'invergel': [
        'INVERGEL IGSTJ 18000'
      ],
      'life-max': [
        'LIFE MAX - LM 18075'
      ],
      'solar-battery': [
        'SOLAR BATTERY - LPT 1220H',
        'SOLAR BATTERY - LPT 1220L',
        'SOLAR BATTERY - LPT 1240H',
        'SOLAR BATTERY - LPT 1240L',
        'SOLAR BATTERY - LPT 1260H',
        'SOLAR BATTERY - LPT 1275L',
        'SOLAR BATTERY - LPT 1280H',
        'SOLAR BATTERY - LPPT 12100H',
        'SOLAR BATTERY - LPPT 12100L',
        'SOLAR BATTERY - LPPT 12150H',
        'SOLAR BATTERY - LPPT 12200L',
        'SOLAR CHARGE CONTROLLER - SCC'
      ]
    },
    amaron: {
      'car-batteries': [
        'Amaron GO 36B20L',
        'Amaron GO 38B20L',
        'Amaron GO 35 BH40B20L',
        'Amaron GO 35 BH38B20R',
        'Amaron GO 42B20R',
        'Amaron GO 50B20L',
        'Amaron GO 80 D 23L'
      ],
      'pro-rider': [
        'Amaron Pro Rider APBTX2.5',
        'Amaron Pro Rider APBTX5L',
        'Amaron Pro Rider APBTX7R',
        'Amaron Pro Rider APBTX9Z',
        'Amaron Pro Rider APBTZ4L',
        'Amaron Pro Rider APBTZ5L',
        'Amaron Pro Rider APBTZ7L',
        'Amaron Pro Rider APBTZ9R'
      ],
      'inverter-batteries': [
        'Amaron Inverter Battery 135Ah',
        'Amaron Inverter Battery 165Ah',
        'Amaron Inverter Battery 200Ah',
        'Amaron Inverter Battery 200Ah (Tall Tubular)',
        'Amaron Inverter Battery 220Ah',
        'Amaron Inverter Battery 100Ah'
      ],
      'tubular-batteries': [
        'Amaron Lit Tubular Battery 150AH',
        'Amaron Current Tubular Battery'
      ],
      'solar-combos': [
        'Amaron Solar Combo 650VA 120Ah',
        'Amaron Solar Combo 675VA',
        'Amaron Solar Combo 1KVA ESATMAN',
        'Amaron Solar Combo EASTMAN ONGRID'
      ]
    },
    lithium: {
      'torque-lithium': [
        'TORQUE 12.8V 1280Wh Lithium Battery',
        'TORQUE 12.8V 200Ah LiFePO4 Battery',
        'TORQUE Lithium Advanced BMS System'
      ],
      'wall-mounted': [
        'TORQUE Smart Wall-Mounted Inverter 5KVA',
        'TORQUE Wall-Mount Hybrid Inverter 3KVA'
      ],
      'solar-solutions': [
        'TORQUE Lithium Solar Complete System'
      ]
    },
    solar: {
      'off-grid': [
        'Solar Inverter 1KVA Pure Sine Wave',
        'Solar Inverter 2KVA Pure Sine Wave',
        'Solar Inverter 3KVA Pure Sine Wave',
        'Solar Inverter 4KVA MPPT',
        'Solar Inverter 8KVA Pure Sine Wave',
        'Solar Inverter 10KVA MPPT'
      ],
      'on-grid': [
        'On-Grid Solar Inverter 3KVA',
        'On-Grid Solar Inverter 5KVA',
        'On-Grid Solar Inverter 10KVA',
        'On-Grid Solar Inverter 15KVA'
      ],
      'hybrid': [
        'Hybrid Solar Inverter 3KVA',
        'Hybrid Solar Inverter 5KVA',
        'Hybrid Solar Inverter 8KVA',
        'Hybrid Solar Inverter 10KVA',
        'Hybrid Battery 5KWh LiFePO4',
        'Hybrid Battery 10KWh LiFePO4'
      ]
    }
  };

  const productCounts = {
    exide: {
      'motor-cycle': 9,
      'car': 19,
      'heavy-vehicles': 7,
      'invamaster': 8,
      'invatubular': 5,
      'instabrite': 7,
      'solar': 11
    },
    luminous: {
      'inverlast': 13,
      'extra-charge': 1,
      'red-charge': 4,
      'power-charge': 2,
      'shakti-charge': 2,
      'invergel': 1,
      'life-max': 1,
      'solar-battery': 12
    },
    amaron: {
      'car-batteries': 7,
      'pro-rider': 8,
      'inverter-batteries': 6,
      'tubular-batteries': 2,
      'solar-combos': 4
    },
    lithium: {
      'torque-lithium': 3,
      'wall-mounted': 2,
      'solar-solutions': 1
    },
    solar: {
      'off-grid': 6,
      'on-grid': 4,
      'hybrid': 6
    }
  };

  // Memoized filtered products based on search query
  const filteredCategories = useMemo(() => {
    if (!searchQuery.trim()) {
      return categories;
    }

    const query = searchQuery.toLowerCase();
    return categories
      .map(category => {
        const matchingProducts = productNames[brand]?.[category.id] || [];
        const matchingIndices = matchingProducts
          .map((name, index) => ({ name, index }))
          .filter(({ name }) => name.toLowerCase().includes(query))
          .map(({ index }) => index);

        return {
          ...category,
          matchingIndices
        };
      })
      .filter(category => category.matchingIndices && category.matchingIndices.length > 0);
  }, [searchQuery, brand, categories]);

  if (!categories || categories.length === 0) {
    return <div className="alert alert-warning">No categories available</div>;
  }

  const categoryIndex = currentPage - 1;

  if (categoryIndex < 0 || categoryIndex >= (searchQuery ? filteredCategories.length : categories.length)) {
    return <div className="alert alert-warning">Invalid page number</div>;
  }

  const displayCategories = searchQuery ? filteredCategories : categories;
  const currentCategory = displayCategories[categoryIndex];

  if (!currentCategory) {
    return <div className="alert alert-warning">Category not found</div>;
  }

  const getProductImage = (categoryId, productIndex) => {
    const images = imagePaths[brand]?.[categoryId];
    return images?.[productIndex] || '/assets/placeholder.jpg';
  };

  const getProductName = (categoryId, productIndex) => {
    const names = productNames[brand]?.[categoryId];
    return names?.[productIndex] || `${currentCategory.name} Product ${productIndex + 1}`;
  };

  const getProductCount = () => {
    return productCounts[brand]?.[currentCategory.id] || 0;
  };

  const generateProducts = () => {
    const count = getProductCount();

    if (count === 0) {
      console.warn(`No products found for ${brand} - ${currentCategory.id}`);
      return [];
    }

    let indicesToShow = Array.from({ length: count }, (_, i) => i);

    if (searchQuery && currentCategory.matchingIndices) {
      indicesToShow = currentCategory.matchingIndices;
    }

    return indicesToShow.map((index) => ({
      id: `${brand}-${currentCategory.id}-${index}`,
      name: getProductName(currentCategory.id, index),
      image: getProductImage(currentCategory.id, index),
      delay: `${(index % 4) * 0.2}s`
    }));
  };

  const products = generateProducts();

  if (products.length === 0) {
    return (
      <div className="alert alert-warning">
        {searchQuery 
          ? `No products found matching "${searchQuery}" in this category.`
          : `No products available for ${currentCategory.name}. Please check the category configuration.`
        }
      </div>
    );
  }

  return (
    <div style={{ width: '100%' }}>
      <div className="category-section" data-category={currentCategory.id} style={{ width: '100%' }}>
        <div style={{ marginBottom: '20px' }}>
          <h3 style={{ marginTop: '20px', marginBottom: '15px', fontWeight: 'bold', color: '#333' }}>
            {currentCategory.name}
          </h3>
          <p style={{ color: '#666', marginBottom: '20px' }}>
            {searchQuery ? `Found ${products.length} matching products` : `Showing ${products.length} products`}
          </p>
        </div>
        
        {/* GRID LAYOUT - FIXED */}
        <div style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))',
          gap: '24px',
          width: '100%'
        }}>
          {products.map((product) => (
            <div key={product.id} style={{ width: '100%' }}>
              <ProductCard
                product={{
                  ...product,
                  categoryName: currentCategory.name
                }}
                delay={product.delay}
                brand={brand}
                categoryId={currentCategory.id}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ProductGrid;